<template>
  <!-- 显示监控列表里的数量信息 -->
  <div >
    <Tooltip transfer placement="right" :delay="300">
        <Button :style="binance_data_style" type="text" style="font-size:12px">{{ show_text }}</Button>
        <div v-for="(item, index) of set_binance_data()" :key="index" slot="content" style="white-space:normal" >
          <p> {{ item }} </p>
        </div>
    </Tooltip>
  </div>
</template>
<script>
export default {
  name: "render_table_view_amount",
  data() {
    return {
      loading_status:false,
      show_text:"",
      binance_data_style:{
        'box-shadow':'none',
      }
    }
  },
  props: {
    binance_data:{
      type: String,
      default:""
    }
  },
  methods:{
    // 处理持仓数量数据，以Tooltip展示在前端上
    set_binance_data() {
      // 仓位信息展示：当前真实持仓占据账户余额的百分比、设计初始开仓数量占据账户余额的百分比、当前真实持仓数量
      //   current_amount_msg = "{}|{}|{}".format(
      //       "{}%".format(round(100 * value["holding"][2] / value["special_state"]["balance"], 1)),
      //       "{}%".format(round(100 * value["special_state"]["account_balance_percent"], 2)),
      //       value["holding"][2]
      //   )
      var res = []
      var data = this.binance_data.split("|")
      this.show_text = data[0]
      for (var i in data) {
        res.push( data[i] )
      }
      res[0] = "真实开仓百分比:    " + res[0]
      res[1] = "设计开仓百分比:    " + res[1]
      res[2] = "当前真实持仓数量:    " + res[2] +" 张"
      return res
    }
  },
  watch: {
  }
};
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>
